import { animated, easings, useSpring } from '@react-spring/web';
import { CORRECT_ANSWER_ANIMATION_DURATION } from './constants';

export const CorrectAnswerArea = ({
  height,
  startX,
  endX,
  correctAnswerX,
  shouldShow,
  disableAnimations,
}: {
  height: number;
  startX: number;
  endX: number;
  correctAnswerX: number;
  shouldShow: boolean;
  disableAnimations: boolean;
}) => {
  const styles = useSpring({
    transform: shouldShow ? 'scaleX(1)' : 'scaleX(0)',
    config: {
      easing: easings.easeOutExpo,
      duration: CORRECT_ANSWER_ANIMATION_DURATION,
    },
    immediate: disableAnimations,
  });

  return (
    <>
      <defs>
        <animated.clipPath id="correct-answer-clip">
          <animated.rect
            style={{
              transformOrigin: `${correctAnswerX}px 100%`,
              transform: styles.transform,
            }}
            width={endX - startX}
            x={startX}
            height={height}
          />
        </animated.clipPath>
      </defs>
      <g clipPath="url(#correct-answer-clip)">
        <use href="#curve" />
      </g>
    </>
  );
};
